module.exports = __webpack_public_path__ + "assets/img/media_27.4806caa4.png";